import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { DuroltLogoIcon } from "../assets/constants/Icons";
import ButtonComponent from "../components/ButtonComponent";

const ErrorPage = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const countdownTimerRef  = useRef(null);

    useEffect(() => {
        countdownTimerRef.current = setTimeout(() => {
            history.push("/");
        }, 10000);

        return () => {
            if (countdownTimerRef.current) {
                clearTimeout(countdownTimerRef.current);
            }
        };
    }, [history]);

    const handleRedirect = () => {
        if (countdownTimerRef.current) {
            clearTimeout(countdownTimerRef.current);
        }
        history.push("/");
    };

    return (
        <div className="error-page">
            <div className="main-container">
                <div className="main">
                    <div className="header-container">
                        <DuroltLogoIcon />
                    </div>
                    <h1>Page Not Available for this Request</h1>
                    <p>Please go to Home Page</p>
                    <ButtonComponent 
                    handleClick={handleRedirect} 
                    title="Go To Home"/>
                </div>
            </div>
        </div>
    );
};

export default ErrorPage;
